import { MenuProps, Menu, styled, Button, alpha } from "@mui/material";
import {
  APP_COLOR,
  APP_HOVER_COLOR,
  FONT_FAMILY,
  TEXT_COLOR,
} from "../../../theme";

export const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(0),
    minWidth: 180,
    color: TEXT_COLOR,
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: TEXT_COLOR,
        marginBottom: 5,
        marginRight: theme.spacing(1.0),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
  [theme.breakpoints.down("md")]: {
    minWidth: "100%",
  },
}));

export const StyledCardAdd = styled(Button)(({ theme }) => ({
  marginBottom: 20,
  marginRight: 20,
  boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.6)",
  borderRadius: 5,
  height: 50,
  width: 190,
  color: "black",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: APP_HOVER_COLOR,
  },
  backgroundColor: APP_COLOR,
  textTransform: "none",
  fontSize: 16,
  fontFamily: FONT_FAMILY,
  marginTop: "3px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    marginRight: 0,
  },
}));
